/**
 * /app/$tenantSlug/me/account/security — Me → Account → Security
 * (passkeys + multi-method 2FA, spec §6.4). Every role: my passkeys and
 * authenticator app. The methods belong to the person (identity), so they
 * apply in every company they use WorkRight with.
 *
 * N1 (2026-10-21): was /me/security (which now redirects here).
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountShell } from "@/components/shared/account-shell";
import { TwoFactorMethods } from "@/components/security/two-factor-methods";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/account/security")({
  component: MySecurityRoute,
});

function MySecurityRoute() {
  return (
    <AccountShell description="How you confirm it's you when you sign in. These apply wherever you use WorkRight.">
      <div className="max-w-3xl">
        <TwoFactorMethods />
      </div>
    </AccountShell>
  );
}
